export const PAYMENT_CONFIRMED_TEXT = 'ยอดเงินถูกต้อง'
